import { toValue } from "vue";

import type { EventsCallback } from "./validation.types";

const aggressive = ["update:modelValue", "blur"];

const eager: EventsCallback<unknown> = (isVisible) => {
  return isVisible ? ["update:modelValue", "blur"] : ["blur"];
};

const onCreatedIfValue = <ModelValue>(
  otherEvents: EventsCallback<ModelValue> | string[],
  watchValue?: unknown,
) => {
  return (isVisible: boolean, value: ModelValue) => {
    const events = Array.isArray(otherEvents)
      ? otherEvents
      : otherEvents(isVisible, value);

    if (toValue(watchValue) || (toValue(watchValue) === undefined && value)) {
      return [...events, "created"];
    }
    return events;
  };
};

export { aggressive, eager, onCreatedIfValue };
